import React, { useEffect, useState } from "react";
import { getParsedNumber } from "../../utils/Common";
import useUserStore from "../../stores/store";

/**
 * Summary should include following params
 * isVatIncluded, subtotal, serviceCharge, vat, serviceChargePercent, vatPercent, grossTotal
 */
export default function PaymentOrderItemsSummary({ summary }) {
  const {isVatIncluded, isServiceChargeIncluded, isSupplementaryDutyIncluded} = useUserStore();
  const [items, setItems] = useState([]);

  useEffect(() => {
    const tmpSummary = [{ key: "subtotal", label: "Subtotal", value: summary.subtotal.toFixed(2) }];

    if (isVatIncluded) {
      setItems(tmpSummary);
      return;
    }

    if (getParsedNumber(summary.sd) > 0 && !isSupplementaryDutyIncluded) {
      tmpSummary.push({
        key: "supplementaryDuty",
        label: `Supplementary duty`,
        value: summary.sd.toFixed(2),
      });
    }
    if (getParsedNumber(summary.serviceCharge) > 0 && !isServiceChargeIncluded) {
      tmpSummary.push({
        key: "serviceCharge",
        label: `Service charge (${summary.serviceChargePercent.toFixed(2)}%)`,
        value: summary.serviceCharge.toFixed(2),
      });
    }

    if (getParsedNumber(summary.vat) > 0 && !isVatIncluded) {
      tmpSummary.push({
        key: "VAT",
        label: `VAT (${summary.vatPercent.toFixed(2)}%)`,
        value: summary.vat.toFixed(2),
      });
    }

    setItems(tmpSummary);
  }, [summary, isVatIncluded, isServiceChargeIncluded, isSupplementaryDutyIncluded]);
  
  return (
    <div className="px-5 py-3 bg-[#FFFBE4]">
      {items.map((item) => (
        <div key={item.label} className="flex items-center justify-between">
          <h1 className="text-black">{item.label}</h1>
          <p className="text-[#354C7B] font-semibold">{item.value} TK</p>
        </div>
      ))}

      <div className="flex justify-between font-bold mt-2">
        <span>Gross Total</span>
        <span>{summary.grossTotal.toFixed(2)} TK</span>
      </div>
    </div>
  );
}
